import {simpleDiff, cleanAndSplit} from './NLP.js';


export function calculateFrameTime(expected, asrOutput){
  let normalTimes = getASR_Timing(asrOutput);

  let asrTranscript = asrOutput.data.text;
  let diff = simpleDiff(expected,asrTranscript);

  return doTimings(diff,normalTimes,expected)
}

function getASR_Timing(asrOutput){
  let frames = [];
  if(asrOutput.data.transcription.length == 0) return null;
  let lastEnd = asrOutput.data.transcription[0].start_time;
  let frameAccumulator = asrOutput.data.transcription.reduce((total,word)=>{
      let frame = word.end_time - lastEnd;
      lastEnd = word.end_time;
      frames.push({word: word.word, frame: frame});
      return total+frame;
    },0);

  let avgFrame = frameAccumulator/asrOutput.data.transcription.length;

  if(frames.length){
    frames.map((frame)=>{
      if(avgFrame > 0){
        let normal = frame.frame/avgFrame;
        frame.normalFrame = normal;
      }else{
        frame.normalFrame = 0;
      }
    });
  }

  return frames;
}

export function doTimings(diff,timings,expected){
  let outTimings = [];
  let expectedText = cleanAndSplit(expected);
  let expectedIndex = 0;
  let timingIndex = 0;

  diff.forEach((block)=>{
    for(let i=0; i<block.count;i++){
      if(block.removed){
        outTimings.push({word: expectedText[expectedIndex],frame: null, normalFrame: null});
        expectedIndex++;
      }else if(block.added){
        timingIndex++;
      }else{
        let nf = (timings && timings[timingIndex]) ? timings[timingIndex].normalFrame : 0;
        let fr = (timings && timings[timingIndex]) ?timings[timingIndex].frame : 0;
        outTimings.push({word:expectedText[expectedIndex],normalFrame: nf,frame: fr});
        timingIndex++;
        expectedIndex++;
      }
    }
  });

  return outTimings;
}